export default __webpack_public_path__ + "media/images/blog/blog-05-370x250-518b86f5f3efa6f1038953f405aee1c3.jpg";